import { h, Component } from 'preact';
import style from './style';

import Footer from '../../components/Footer';

// eslint-disable-next-line react/prefer-stateless-function
class AccountDeletion extends Component {
	render() {
		return (
			<div class={style.pageContainer}>
				<div class={style.cardContainer}>
					<h1 class={style.title}>MuseLab Account Deletion Request</h1>
					<p>
						This page is for any account holders on 8:36pm, PlayNow, or Coaster that wish to delete their accounts.
					</p>
					<p>
						Upon request, we will delete your account and all associated data with it.
					</p>
					<p>
						If you'd like to delete your account, please contact us at <a href="mailto:support@muselab.io">support@muselab.io</a> and simply tell us for which app you'd like your account to be deleted.
					</p>
				</div>
				<Footer />
			</div>
		);
	}
}

export default AccountDeletion;



// WEBPACK FOOTER //
// ./routes/accountdeletion/AccountDeletion.jsx